// plugins/server-info.js
export default defineNuxtPlugin((nuxtApp) => {
    // 只在服务端执行
    if (process.server) {
        // console.log('nuxtApp', nuxtApp)
        const clientInfo = nuxtApp.ssrContext.event.context.clientInfo
        // 使用 useState 创建响应式状态
        const clientIp = useState('clientInfo', () => clientInfo)
    }
})
